module.exports = __webpack_public_path__ + "img/gameTronos7.b05eb581.jpg";